import { useState, useEffect, useContext } from "react";
import {
  Box,
  Grid,
  Stack,
  Button,
  TextField,
  Typography,
  InputAdornment,
} from "@mui/material";
import "../../Style/pagestyle.scss";

import { useQuery } from "@apollo/client";
import { AuthContext } from "../../Context/AuthContext";
import { GET_STUDENT_WITH_PAGINATION } from "../../Schema/Student";

import SearchIcon from "@mui/icons-material/Search";
import CreateIcon from "../../Assets/create-icon.svg";
import ClassCard from "../../Components/StudyClass/ClassCard/ClassCard";

import { SelectUser } from "../../Components/Include/DynamicSelect/DynamicSelect"; 

export default function StudentEnrollment() {
  // Change Language
  const { t } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [tableData, setTableData] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [paginationData, setPaginationData] = useState();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  let pageStudent = window.localStorage.getItem("pageStudent");
  const { refetch } = useQuery(GET_STUDENT_WITH_PAGINATION, {
    variables: {
      page: page,
      limit: limit,
      keyword: keyword,
    },
    onCompleted: ({ getStudentsWithPagination }) => {
      setTableData(getStudentsWithPagination?.data);
      setPaginationData(getStudentsWithPagination?.paginator);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  const handleSearch = (e) => {
    setPage(1);
    setKeyword(e.target.value);
  };

  useEffect(() => {
    refetch();
  }, [page, open, keyword]);

  useEffect(() => {
    if (pageStudent) {
      setPage(parseInt(pageStudent));
    } else {
      setPage(1);
    }
  }, [pageStudent]);

  // ======================= Resize width Screen ======================
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth - 50);
  };

  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  return (
    <div className="page-container">
      <Stack direction="column" rowGap={2.2}>
        <Grid container spacing={3}>
          {[1, 2, 3, 4, 5, 6, 7, 8, 9].map(() => (
            <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
              <ClassCard />
            </Grid>
          ))}
        </Grid>
      </Stack>
    </div>
  );
}
